var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 36",
    style: {
      enableBackground: "new 0 0 28 36"
    },
    xmlSpace: "preserve",
    width: 28,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#036BA5",
    d: "M14,1C7.6,1,1,6.1,1,14.5c0,2.1,0.7,4.3,1.8,6.5c1,2.2,2.4,4.3,3.8,6.3c2.8,3.8,5.6,6.8,5.8,7 c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.6,0.2,0.9,0.2s0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,3-3.2,5.8-7 c1.4-1.9,2.8-4.1,3.8-6.3c1-2.2,1.8-4.4,1.8-6.5C27,6.1,20.4,1,14,1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 14,
    cy: 14.1,
    r: 10.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#036BA5",
    d: "M18.3,14.5L18.3,14.5c-0.5,0-1-0.1-1.4-0.4c-0.4,0.2-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 c-0.4,0.2-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4c-0.4,0.2-0.9,0.4-1.4,0.4c-0.2,0-0.4,0-0.6-0.1v5.4c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.1,0.3,0.1h3.3v-2.9h2.5v2.9h3.3c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3v-5.4C18.7,14.5,18.5,14.5,18.3,14.5z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036BA5",
    d: "M20.5,11.4L18,8.2c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0h-7.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.1 l-2.4,3.3c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.6,0.3,1.1,0.7,1.4c0.4,0.4,1,0.6,1.5,0.6c0.5,0,1-0.2,1.4-0.5c0.4,0.3,0.9,0.5,1.4,0.5 c0.5,0,1-0.2,1.4-0.5c0.4,0.3,0.9,0.5,1.4,0.5c0.5,0,1-0.2,1.4-0.5c0.4,0.3,0.9,0.5,1.4,0.5c0.6,0,1.1-0.2,1.5-0.6 c0.4-0.4,0.7-0.9,0.7-1.4C20.5,11.6,20.5,11.5,20.5,11.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerStore);
export default __webpack_public_path__ + "static/media/markerStore.68ebfbad91e53a63529e800ff8971b89.svg";
export { ForwardRef as ReactComponent };